<style scoped>
.login-wrap {
  width: 100%;
  height: 100%;
  background: #2d3a4b;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-form {
  width: 400px;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}
.captcha-wrap {
  display: flex;
  align-items: center;
}
</style>

<template>
  <div class="login-wrap">
    <div class="login-form">
      <div class="login-title">矿山修复监测管理平台</div>
      <el-form :model="form" :rules="rules" ref="loginForm" label-width="80px">
        <el-form-item label="账号" prop="account">
          <el-input v-model="form.account" placeholder="请输入账号" @keyup.enter.native="handleLogin"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码" @keyup.enter.native="handleLogin"></el-input>
        </el-form-item>
        <el-form-item label="所属区县" prop="district">
          <el-cascader
            style="width: 100%;"
            v-model="selectedOptions"
            :options="regionData"
            :props="{ value: 'value', label: 'label', children: 'children' }"
            @change="handleChange"
            placeholder="请选择所属区县"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%;" :loading="loading" @click="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";

export default {
  data() {
    return {
      loading: false,
      regionData: regionData,
      selectedOptions: ["430000", "431000", "431021"], // 湖南省-郴州市-桂阳县
      form: {
        account: "",
        password: "",
        provinceId: "430000",
        provinceName: "湖南省",
        cityId: "431000",
        cityName: "郴州市",
        districtId: "431021",
        districtName: "桂阳县"
      },
      rules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  created() {
    // 如果已经登录，直接跳转首页
    const token = localStorage.getItem("adminToken");
    if (token) {
      this.$router.push("/");
    }
  },
  methods: {
    handleChange(value) {
      this.form.provinceId = value[0];
      this.form.provinceName = CodeToText[value[0]];
      this.form.cityId = value[1];
      this.form.cityName = CodeToText[value[1]];
      this.form.districtId = value[2];
      this.form.districtName = CodeToText[value[2]];
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid) return;
        this.loading = true;
        this.$apis
          .post("/admin/backendUser/login", this.form)
          .then(res => {
            this.loading = false;
            if (res.data.code == 200) {
              const data = res.data.data;
              // 存储到 Vuex
              this.$store.commit("setToken", data.token);
              this.$store.commit("setAdminUserInfo", data);
              this.$store.commit("setDistrictInfo", {
                provinceId: data.provinceId,
                provinceName: data.provinceName,
                cityId: data.cityId,
                cityName: data.cityName,
                districtId: data.districtId,
                districtName: data.districtName
              });
              // 存储到 localStorage
              localStorage.setItem("adminToken", data.token);
              localStorage.setItem("adminUserInfo", JSON.stringify(data));
              this.$message.success("登录成功");
              this.$router.push("/");
            } else {
              this.$message.error(res.data.msg || "登录失败");
            }
          })
          .catch(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/login.vue